'use client';
import Link from 'next/link';
import { useEffect, useState } from 'react';
type Order={id:string;status:string;customer:{name:string;phone:string;email:string;address:string;lat:number;lng:number};items:{name:string;color:string;quantity:number;purchased:boolean}[];subtotal_idr:number;shipping_idr:number|null};
const money=(n:number)=>new Intl.NumberFormat('id-ID',{style:'currency',currency:'IDR',maximumFractionDigits:0}).format(n);
export default function Admin(){const [orders,setOrders]=useState<Order[]>([]),[error,setError]=useState(''),[busy,setBusy]=useState(false),[shipping,setShipping]=useState<Record<string,string>>({});
async function load(){setError('');try{const r=await fetch('/api/admin/orders',{cache:'no-store'});if(!r.ok)throw Error(r.status===401?'Akses admin ditolak oleh proxy. Pastikan Anda telah masuk.':`Gagal memuat pesanan (${r.status}).`);const d=await r.json() as {orders?:Order[]};if(!Array.isArray(d.orders))throw Error('Respons pesanan tidak valid.');setOrders(d.orders);}catch(e){setOrders([]);setError(e instanceof Error?e.message:'Gagal memuat pesanan.');}}
useEffect(()=>{const timer=setTimeout(()=>{void load();},0);return()=>clearTimeout(timer);},[]);
async function update(payload:Record<string,unknown>){setBusy(true);setError('');try{const r=await fetch('/api/admin/orders',{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}),d=await r.json();if(!r.ok)throw Error(d.error||'Perubahan gagal');await load();}catch(e){setError(e instanceof Error?e.message:'Gagal menyimpan');}finally{setBusy(false);}}
return (
  <main className="admin-shell">
    <header className="admin-head">
      <Link className="brand" href="/">jastip<span>.</span></Link>
      <nav className="catalog-admin-nav" aria-label="Navigasi admin"><Link href="/admin" aria-current="page">Pesanan</Link><Link href="/admin/products">Katalog</Link></nav>
      <span>PANEL ADMIN</span>
    </header>
    {error && <p className="notice error" role="alert">{error}</p>}
    <section className="admin-title">
      <p className="eyebrow">DASHBOARD</p>
      <h1>Pesanan titipan</h1>
      <p>Periksa detail tujuan, tetapkan ongkir, lalu tandai barang yang sudah dibeli.</p>
    </section>
    {orders.length === 0 ? <p className="empty">Belum ada pesanan di lingkungan ini.</p> : (
      <div className="orders">
        {orders.map((o) => (
          <article className="order-card" key={o.id}>
            <div className="order-head">
              <div><span className="eyebrow">{o.id}</span><h2>{o.customer.name}</h2></div>
              <b className="status">{o.status === 'awaiting_shipping_quote' ? 'Perlu kutip ongkir' : o.status === 'awaiting_payment' ? 'Menunggu pembayaran' : o.status}</b>
            </div>
            <p>{o.customer.phone} · {o.customer.email}</p>
            <p>{o.customer.address}</p>
            <p>Koordinat: {o.customer.lat}, {o.customer.lng} · <a href={`https://www.openstreetmap.org/?mlat=${o.customer.lat}&mlon=${o.customer.lng}#map=17/${o.customer.lat}/${o.customer.lng}`} target="_blank" rel="noreferrer">Lihat di peta ↗</a></p>
            <div className="admin-items">
              {o.items.map((item, index) => (
                <label key={index} className="purchased">
                  <input type="checkbox" checked={item.purchased} onChange={(event) => void update({ id: o.id, action: 'purchased', item_index: index, value: event.target.checked })} />
                  {item.name} · {item.color} × {item.quantity}
                </label>
              ))}
            </div>
            <p>Subtotal barang: <b>{money(o.subtotal_idr)}</b>{o.shipping_idr !== null && <> · Ongkir: <b>{money(o.shipping_idr)}</b> · Total: <b>{money(o.subtotal_idr + o.shipping_idr)}</b></>}</p>
            {o.status === 'awaiting_shipping_quote' && (
              <div className="quote">
                <label>Ongkir (IDR)<input type="number" min="0" step="1" value={shipping[o.id] ?? ''} onChange={(event) => setShipping({ ...shipping, [o.id]: event.target.value })} /></label>
                <button className="button" disabled={busy || shipping[o.id] === ''} onClick={() => void update({ id: o.id, action: 'quote', shipping_idr: Number(shipping[o.id]) })}>Kirim kutipan ongkir</button>
                <button className="cancel" disabled={busy} onClick={() => void update({ id: o.id, action: 'cancel' })}>Batalkan pesanan</button>
              </div>
            )}
          </article>
        ))}
      </div>
    )}
  </main>
);
}
